<template>
  <div class="low-stock">
    <div class="low-stock__head">
      <span class="low-stock__icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 3.2L21.6 20.2H2.4L12 3.2Z"
            fill="#FACC15"
            stroke="#111"
            stroke-width="1.8"
            stroke-linejoin="round"
          />
          <path
            d="M12 9.2V14.4"
            stroke="#111"
            stroke-width="1.8"
            stroke-linecap="round"
          />
          <circle
            cx="12"
            cy="16.8"
            r="1"
            fill="#111"
          />
        </svg>
      </span>
      <div class="low-stock__title">{{ $t('orderPointList') }}</div>
    </div>
    <div
      v-if="canSee"
      ref="scrollContainer"
      class="low-stock__list"
    >
      <button
        v-for="item in items"
        :key="item.id"
        type="button"
        class="low-stock__row"
        @click="edit(item)"
      >
        <span class="low-stock__thumb">
          <img
            :src="item.avatar && item.avatar.link ? item.avatar.link : placeholder"
            alt=""
          >
        </span>
        <span class="low-stock__meta">
          <span class="low-stock__name">{{ item.name }}</span>
          <span class="low-stock__sub">
            {{ item.group ? item.group.name : '-' }}{{ item.cat1 ? '، ' + item.cat1.name : '' }}
          </span>
        </span>
        <span class="low-stock__count">
          {{ stockCount(item) }}
          {{ item.unit && item.unit.fame ? item.unit.fame : $t('piece') }}
        </span>
      </button>
      <div
        v-if="!loading && !items.length"
        class="low-stock__empty"
      >
        <home-empty-state :size="80" />
      </div>
      <div
        v-if="loading || loadingPaginate"
        class="low-stock__more"
      >
        <v-progress-circular
          :width="3"
          color="blue"
          indeterminate
          size="22"
        />
      </div>
    </div>
    <div
      v-else
      class="low-stock__empty"
    >
      {{ $t("you don't have access to this information") }}
    </div>
    <button
      v-if="canSee"
      type="button"
      class="low-stock__all"
      @click="goAll"
    >
      {{ $t('viewAll') }}
    </button>
  </div>
</template>

<script>
import HomeEmptyState from './HomeEmptyState.vue'

export default {
  name: 'HomeLowStock',
  components: { HomeEmptyState },
  data () {
    return {
      items: [],
      page: 1,
      lastPage: 1,
      loading: false,
      loadingPaginate: false,
      placeholder: require('@/assets/imagePlacholder.png')
    }
  },
  computed: {
    canSee () {
      return this.$store.getters.getpermission && this.$store.getters.getpermission.includes('overview')
    }
  },
  mounted () {
    this.fetchList()
    this.$nextTick(() => {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll)
      }
    })
  },
  beforeDestroy () {
    if (this.$refs.scrollContainer) {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    stockCount (item) {
      if (!item.stock || item.stock.count == null) return '-'
      return this.$numberFormat(item.stock.count)
    },
    goAll () {
      this.$router.push({ name: 'ProductList' }).catch(() => {})
    },
    edit (item) {
      this.$router.push({ name: 'ProductEdit', params: { id: item.id } }).catch(() => {})
    },
    handleScroll () {
      const el = this.$refs.scrollContainer
      if (!el || this.loadingPaginate || this.page >= this.lastPage) return
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 8) {
        this.page += 1
        this.fetchList(true)
      }
    },
    fetchList (paginate) {
      if (paginate) this.loadingPaginate = true
      else this.loading = true
      this.$axios.get(this.$endpoint + 'products', {
        params: {
          inventoryStatus: 'orderpoint',
          page: this.page,
          typeForm: 'product',
          options: JSON.stringify({ page: this.page, itemsPerPage: 20 })
        }
      }).then(res => {
        const rows = (res.data && res.data.data) || []
        this.items = paginate ? this.items.concat(rows) : rows
        this.lastPage = (res.data && res.data.last_page) || 1
      }).catch(() => {
        if (!paginate) this.items = []
      }).finally(() => {
        this.loading = false
        this.loadingPaginate = false
      })
    }
  }
}
</script>

<style scoped>
.low-stock {
  background: #FFFDF5;
  border: 1px solid #F3E8C8;
  border-radius: 4px;
  padding: 12px 14px;
  height: 324px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.low-stock__head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.low-stock__icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.low-stock__icon svg {
  display: block;
}
.low-stock__title {
  font-size: 13px;
  font-weight: 700;
  color: #111;
  line-height: 1;
}
.low-stock__all {
  flex-shrink: 0;
  width: 100%;
  height: 34px;
  margin-top: 8px;
  border: none;
  background: none;
  color: #0066FF;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
}
.low-stock__list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.low-stock__list::-webkit-scrollbar {
  width: 4px;
}
.low-stock__list::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 4px;
}
.low-stock__row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #F3F4F6;
  background: none;
  cursor: pointer;
  text-align: start;
}
.low-stock__row:last-child {
  border-bottom: none;
}
.low-stock__thumb {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  background: #F3F4F6;
}
.low-stock__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.low-stock__meta {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.low-stock__name {
  font-size: 12px;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.low-stock__sub {
  font-size: 11px;
  color: #9CA3AF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.low-stock__count {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  color: #111;
  white-space: nowrap;
}
.low-stock__empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #6B7280;
  text-align: center;
  min-height: 120px;
}
.low-stock__more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}
@media (max-width: 1220px) {
  .low-stock {
    height: 403px;
  }
}
</style>
